import React from 'react';

export const TextBoxAnswerField = ({
	rows = 5,
	fieldValue = null,
	onAnswerChange
}) => {
	
	return (
		<div>
			<textarea className='form-control'
				rows={rows}
				placeholder='Paragraph'
				value={fieldValue ?? ''}
				onChange={(e) => onAnswerChange(e.target.value)}
				maxLength={255} >
			</textarea>
			<div className='text-end text-secondary'>  {fieldValue.length + '/255 characters remaining'}</div>
		</div>
	);
};

export default TextBoxAnswerField;
